// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 355) return "static/chunks/355-04ecb2e7b9d54c8a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "9bb19ee50de29c3d" + ".js";
};